import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { api } from '../../Api';

// Link do I.A Prof (pode ser trocado pelo .env do client: REACT_APP_IAPROF_URL=https://...)
const IAPROF_URL = process.env.REACT_APP_IAPROF_URL || 'https://ia-prof.netlify.app';

const Wrap = styled.div`
  position: relative;
  width: 100%;
  @media print { display: none !important; }
`;

const Box = styled.a`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  box-sizing: border-box;
  padding: 14px 44px 14px 16px;
  border-radius: 14px;
  text-decoration: none;
  cursor: pointer;
  background: linear-gradient(135deg, #eef2ff 0%, #f5f3ff 100%);
  border: 1px solid #c7d2fe;
  color: #312e81;
  transition: transform .12s ease, box-shadow .15s ease;

  &:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(67, 56, 202, .15); }

  .icon {
    flex-shrink: 0;
    width: 42px; height: 42px;
    border-radius: 12px;
    display: grid; place-items: center;
    background: #4338ca; color: #fff;
    font-size: 20px; font-weight: 800;
  }
  .text { flex: 1; min-width: 0; }
  strong { display: block; font-size: 15px; line-height: 1.3; }
  p { margin: 3px 0 0; font-size: 13px; line-height: 1.45; color: #4338ca; }
  .cta {
    flex-shrink: 0;
    padding: 8px 14px;
    border-radius: 999px;
    background: #4338ca; color: #fff;
    font-size: 13px; font-weight: 700;
    white-space: nowrap;
  }

  @media (max-width: 540px) {
    flex-wrap: wrap;
    .cta { width: 100%; text-align: center; }
  }
`;

const NuncaMais = styled.button`
  display: block;
  margin: 6px 0 0 auto;
  padding: 2px 4px;
  border: none;
  background: transparent;
  color: var(--text-muted, #6b7280);
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
  &:hover { color: #312e81; }
`;

const Close = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: rgba(67, 56, 202, .12);
  color: #312e81;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  &:hover { background: rgba(67, 56, 202, .22); }
`;

// Fechar vale até o próximo login: fica no sessionStorage, que o "Sair" limpa
// (e que acaba ao fechar a aba — onde o login também acaba).
const CHAVE_FECHADO = 'iaprof-banner-fechado';
const lerFechado = () => {
    try { return sessionStorage.getItem(CHAVE_FECHADO) === '1'; } catch { return false; }
};

/**
 * Anúncio do I.A Prof.
 * - Some se o professor já conectou a conta ao I.A Prof.
 * - O "×" esconde até o próximo login.
 */
export function IAProfBanner() {
    const [fechado, setFechado] = useState(lerFechado);
    const [vinculado, setVinculado] = useState(false);
    const [nuncaMais, setNuncaMais] = useState(false);

    useEffect(() => {
        let ativo = true;
        api.get('/employee/iaprof-status')
            .then((r) => {
                if (!ativo) return;
                if (r?.data?.vinculado) setVinculado(true);
                if (r?.data?.oculto) setNuncaMais(true);
            })
            .catch(() => { /* sem status: mostra o anúncio */ });
        return () => { ativo = false; };
    }, []);

    if (fechado || vinculado || nuncaMais) return null;

    const naoMostrarMais = () => {
        setNuncaMais(true); // some na hora; o servidor guarda para os próximos logins
        api.post('/employee/iaprof-banner/ocultar').catch(() => { /* tenta de novo na próxima vez */ });
    };

    return (
        <Wrap>
            <Box
                href={IAPROF_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Conhecer o I.A Prof (abre em nova aba)"
                onClick={(e) => {
                    // abre explicitamente (evita bloqueio por algum handler da tela)
                    e.preventDefault();
                    e.stopPropagation();
                    const aba = window.open(IAPROF_URL, '_blank');
                    if (aba) aba.opener = null;            // segurança: a nova aba não controla o D.E.V.
                    else window.location.href = IAPROF_URL; // pop-up bloqueado: abre na mesma aba
                }}
            >
                <span className="icon">✦</span>
                <span className="text">
                    <strong>Crie aulas e atividades em minutos com o I.A Prof</strong>
                    <p>Seu assistente com inteligência artificial monta planos de aula e atividades alinhados à BNCC e registra tudo direto no seu diário.</p>
                </span>
                <span className="cta">Conhecer o I.A Prof →</span>
            </Box>
            <Close type="button" aria-label="Fechar anúncio" title="Fechar" onClick={() => {
                    try { sessionStorage.setItem(CHAVE_FECHADO, '1'); } catch { /* sem storage: fecha só agora */ }
                    setFechado(true);
                }}>
                ×
            </Close>
            <NuncaMais type="button" onClick={naoMostrarMais}>
                Não mostrar mais
            </NuncaMais>
        </Wrap>
    );
}

export default IAProfBanner;
